module.exports = __webpack_public_path__ + "img/avyda_header.c0cfa609.png";